import { render, staticRenderFns } from "./GithubFeed.vue?vue&type=template&id=aaeb4c7e&scoped=true&"
import script from "./GithubFeed.vue?vue&type=script&lang=js&"
export * from "./GithubFeed.vue?vue&type=script&lang=js&"
import style0 from "./GithubFeed.vue?vue&type=style&index=0&id=aaeb4c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaeb4c7e",
  null
  
)

export default component.exports